module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/26-296fbea3a62f884702be8c257221a85b.jpg";